import { FaCircleCheck } from "react-icons/fa6"
import { IoWarning } from "react-icons/io5"
import { Icon, Spinner } from "@chakra-ui/react"
import { Button, PulsingDot } from "@/components"
import { ComplianceType, UploadedDocument } from "@/types"
import { isCompleted } from "../utils"

interface Props {
  type: ComplianceType
  isLoading: boolean
  currentComplianceType: ComplianceType | null
  complianceDocuments: UploadedDocument[]
  setCurrentComplianceType: (type: ComplianceType) => void
  isNdaFormCompleted?: boolean
}

export const ComplianceTab = ({ type, isLoading, currentComplianceType, complianceDocuments, setCurrentComplianceType, isNdaFormCompleted }: Props) => {
  const renderIndicator = () => {
    if (isLoading) return <Spinner size="xs" />

    if (isCompleted(type, complianceDocuments)) {
      return <Icon as={FaCircleCheck} boxSize={4} color="green.500" />
    }

    if (type === ComplianceType.NDA && isNdaFormCompleted) {
      return <Icon as={IoWarning} boxSize={4} color="yellow.500" />
    }

    return <PulsingDot animationCount={3} />
  }

  return (
    <Button
      variant={ type === currentComplianceType ? "tabSelected" : "tabUnselected"}
      onClick={() => setCurrentComplianceType(type)}
    >
      {type}
      {renderIndicator()}
    </Button>
  )
}
